export default "__VITE_ASSET__CaDfkMwc__"